(function () {
    function getClosest(element, selector) {
        while (element && element !== document) {
            if (element.matches(selector)) {
                return element;
            }

            element = element.parentNode;
        }

        return null;
    }

    function setActiveButton(activeType) {
        var buttons = document.querySelectorAll('[data-shipping-toggle]');
        var i;

        for (i = 0; i < buttons.length; i++) {
            if (buttons[i].getAttribute('data-shipping-toggle') === activeType) {
                buttons[i].classList.add('delivery-buttons__button--checked');
            } else {
                buttons[i].classList.remove('delivery-buttons__button--checked');
            }
        }
    }

    function toggleNoDeliveryMessage(activeType) {
        var messages = document.querySelectorAll('[data-delivery-message="unavailable"]');
        var i;

        for (i = 0; i < messages.length; i++) {
            if (activeType === 'delivery') {
                messages[i].removeAttribute('hidden');
            } else {
                messages[i].setAttribute('hidden', 'hidden');
            }
        }
    }

    document.addEventListener('click', function (event) {
        var button = getClosest(event.target, '[data-shipping-toggle]');
        var activeType;
        var targetId;
        var input;

        if (!button) {
            return;
        }

        if (button.getAttribute('aria-disabled') === 'true') {
            event.preventDefault();
            return;
        }

        activeType = button.getAttribute('data-shipping-toggle');
        targetId = button.getAttribute('for');

        /**
         * If this tab is a real label for a real WooCommerce shipping radio,
         * let WooCommerce handle it normally. This keeps the existing AJAX behaviour.
         */
        if (targetId) {
            input = document.getElementById(targetId);

            if (input) {
                setActiveButton(activeType);
                toggleNoDeliveryMessage(activeType);
                return;
            }
        }

        /**
         * If there is no real radio input, this is just a UI toggle.
         * For example, Delivery when no delivery method is currently available.
         */
        event.preventDefault();

        setActiveButton(activeType);
        toggleNoDeliveryMessage(activeType);
    });
}());